import { Store, Package, FolderTree, Tag, RefreshCw } from 'lucide-react'

export interface CatalogNavTabItem {
  name: string
  path: string
  icon: React.ComponentType<{ className?: string }>
  description?: string
}

export function buildCatalogNavTabs(itemsPluralName: string): CatalogNavTabItem[] {
  return [
    { name: 'Vitrina y Enlaces', path: '/app/catalog', icon: Store, description: 'Resumen y catálogo público' },
    { name: itemsPluralName, path: '/app/products', icon: Package, description: 'Inventario y precios' },
    { name: 'Categorías', path: '/app/categories', icon: FolderTree, description: 'Departamentos y filtros' },
    { name: 'Promociones', path: '/app/promotions', icon: Tag, description: 'Campañas y descuentos' },
    { name: 'Sincronización', path: '/app/inventory-sync', icon: RefreshCw, description: 'Google Sheets y API externa' },
  ]
}

export const CATALOG_NAV_TABS = buildCatalogNavTabs('Productos')
